import { create } from 'zustand';

const useCartStore = create((set, get) => ({
  cartItems: [],
  cartDialogOpen: false,
  cartDialogUpdate: false,
  selectedRestaurantId: null,
  newItemToOrder: null,
  erneutbestellen: false,
  progress: 0,

  setCartItems: (items) =>
    set({
      cartItems: typeof items === 'function' ? items(get().cartItems) : items,
    }),
  addItem: (item) => set((s) => ({ cartItems: [...s.cartItems, item] })),
  removeItem: (index) =>
    set((s) => ({ cartItems: s.cartItems.filter((_, i) => i !== index) })),
  updateQuantity: (index, qty) =>
    set((s) => ({
      cartItems: s.cartItems.map((item, i) =>
        i === index ? { ...item, quantity: qty } : item,
      ),
    })),
  clearCart: () => set({ cartItems: [] }),

  setCartDialogOpen: (open) => set({ cartDialogOpen: open }),
  setCartDialogUpdate: (update) => set({ cartDialogUpdate: update }),
  setSelectedRestaurantId: (id) => set({ selectedRestaurantId: id }),
  setNewItemToOrder: (item) => set({ newItemToOrder: item }),
  setErneutbestellen: (val) => set({ erneutbestellen: val }),
  setProgress: (val) => set({ progress: val }),
}));

export default useCartStore;
